import { render, staticRenderFns } from "./PersonNameDemo.vue?vue&type=template&id=57018489"
import script from "./PersonNameDemo.vue?vue&type=script&lang=js"
export * from "./PersonNameDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports